import { useRef, useEffect } from "react";
import { TRIP_DATES, weekdayShort, dayNum } from "@/lib/dates";
import { useTrip } from "@/lib/store";

export function DateStrip({ value, onChange }) {
  const { trip, today } = useTrip();
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current?.querySelector(`[data-date="${value}"]`);
    el?.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
  }, [value]);
  return (
    <div data-testid="date-selector-strip" ref={ref} className="no-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4 py-2 md:mx-0 md:px-0">
      {TRIP_DATES.map((d) => {
        const day = trip.days.find((x) => x.date === d);
        const active = d === value;
        const isToday = d === today;
        const count = trip.events.filter((e) => e.date === d).length + trip.transports.filter((t) => t.date === d).length;
        return (
          <button key={d} data-date={d} data-testid={`date-pill-${d}`} onClick={() => onChange(d)}
            className={`tap relative flex min-w-[64px] flex-col items-center rounded-2xl border px-2 py-2.5 ${active ? "border-[var(--jade)] bg-[var(--jade)] text-[var(--parchment)]" : "bg-white text-[var(--ink)]"}`}>
            <span className={`text-[10px] font-semibold uppercase tracking-[0.14em] ${active ? "text-[var(--parchment)]/80" : "text-[var(--ink-muted)]"}`}>{weekdayShort(d)}</span>
            <span className="font-display text-2xl font-semibold leading-none mt-0.5">{dayNum(d)}</span>
            <span className={`mt-1 text-[9px] font-semibold uppercase tracking-wider ${active ? "text-[var(--parchment)]/80" : "text-[var(--ink-muted)]"}`}>{day?.transition ? "Travel" : day?.city.split(" ")[0]}</span>
            {count > 0 && <span className={`mt-1 h-1 w-1 rounded-full ${active ? "bg-[var(--coral)]" : "bg-[var(--brass)]"}`} />}
            {isToday && <span className="absolute -top-1 right-1 rounded-full bg-[var(--coral)] px-1.5 text-[8px] font-bold uppercase text-white">Today</span>}
          </button>
        );
      })}
    </div>
  );
}
